import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'password',
    templateUrl: './password.component.html',
    styleUrls: ['./password.component.scss'],
    standalone: false
})
export class PasswordComponent {
  @Input() password = '';
  @Input() placeholder = '';
  @Output() passwordChange = new EventEmitter<string>();
  isPasswordVisible = false;

  onPasswordInput(value: any): void {
    this.password = value.value;
    this.passwordChange.emit(this.password);
  }
}
